Ext.define('SA.EmptySidebar', {
    alias: 'widget.empty-sidebar',
    extend: 'SA.view.SimpleContainer',

    baseCls: 'sa-empty-sidebar',

    items: [
        {
            xtype: 'component',
            cls: 'sa-empty-sidebar-mask'
        }, {
            xtype: 'sa-search-field',
            cls: 'sa-sidebar-search-field'
        }
    ]
});